var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocationUnderline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M6.688 26.688h18.624v2.624H6.688zm6.624-16q0 1.088.8 1.856a2.66 2.66 0 0 0 1.904.768 2.6 2.6 0 0 0 1.888-.768 2.5 2.5 0 0 0 .784-1.856q0-1.088-.8-1.888T16 8t-1.888.8-.8 1.888m10.688 0q0 1.665-.832 3.808-.704 1.824-1.984 3.936a46 46 0 0 1-2.368 3.456 46 46 0 0 1-1.984 2.464l-.832.96-.832-.96a46 46 0 0 1-1.984-2.464 46 46 0 0 1-2.368-3.456q-1.28-2.112-1.984-3.936Q8 12.351 8 10.688q0-2.176 1.072-4.016a7.94 7.94 0 0 1 2.912-2.912A7.84 7.84 0 0 1 16 2.688q2.176 0 4.016 1.072a7.94 7.94 0 0 1 2.912 2.912A7.84 7.84 0 0 1 24 10.688"
})));
export default SvgLocationUnderline;